import React, { useEffect, useState } from 'react'
import MainLayout from 'layouts/main'
import Page from '@zera-admin/page'
import Breadcrumb, { BreadcrumbItem } from '@zera-admin/breadcrumb'
import { Column, PageHeader, Row } from '@zera-admin/page'
import Button from '@zera-admin/button'
import Checkbox from '@zera-admin/checkbox'
import Input from '@zera-admin/input'
import Select, { SelectOptionProps } from '@zera-admin/select'
import { RadioGroup } from '@zera-admin/radio'
import { useFlagcardContext } from 'app/contexts/flagcard'

import definitionService from 'services/http/backoffice/definition'
import { DefinitionFormProps, SocialMediaEnum } from '../../types'
import Form, {
  FormFooter,
  FormHookSubmitProps,
  FormSection,
  useForm,
} from '@zera-admin/form'
import { TwitterQueryRequest } from 'services/http/backoffice/definition/types'
import DateTimePicker from '@zera-admin/datetime-picker'
import { DateTimePickerHours } from 'app/shared/enums'

const Twitter: React.FunctionComponent<DefinitionFormProps> = ({
  actions = [],
  onError,
  values,
}) => {
  const [isLoading, setIsLoading] = useState<boolean>()

  const [countData, setCountData] = useState<any>()

  const [dateError, setDateError] = useState<boolean>(false)

  const [dateFilter, setDateFilter] = useState<any>({
    dateSince: '',
    dateUntil: '',
  })

  const [isSubmit, setIsSubmit] = useState<boolean>()

  const [languagesV2, setLanguagesV2] = useState<any[]>([])

  const [flagcard] = useFlagcardContext()

  const hoursArray: string[] = []
  for (const key in DateTimePickerHours) {
    if (typeof DateTimePickerHours[key] === 'string') {
      hoursArray.push(DateTimePickerHours[key])
    }
  }

  const definitionTypeOptions = [
    { label: 'Keyword', value: 'keyword' },
    { label: 'Account', value: 'account' },
  ]

  const changeCrawlingSource = (source: SocialMediaEnum) => {
    form.handleFieldChange('crawlingSource', source)
  }

  const handleTwitter = () => {
    changeCrawlingSource(SocialMediaEnum.Twitter)
    
    // İlk açılışta default tarih değerlerini set et
    const oneDayAgo = new Date()
    oneDayAgo.setDate(oneDayAgo.getDate() - 1)
    const now = new Date()
    
    form.handleBatchUpdate({
      definitionValue: '',
      definitionType: 'keyword',
      fetchKeywordSince: oneDayAgo.toISOString(), // İlk açılışta 1 gün önce
      fetchKeywordUntil: now.toISOString(), // İlk açılışta şu an
    })
  }

  const form = useForm<TwitterQueryRequest>({
    initialValues: values,
    onSubmit: (props) => handleSubmit(props),
  })

  const handleSubmit = (props: FormHookSubmitProps<TwitterQueryRequest>) => {
    if (!props.errors) {
      if (form.values) {
        definitionService
          .twitterFetch(form.values)
          .then((res: any) => {
            setCountData(res.data.data)
            setIsSubmit(true)
            flagcard.add({
              appearance: 'success',
              title: 'Sorgulama işlemi başarılı',
              children: 'Sorgu sonucu aşağıdaki gibidir.',
            })
            // Hiçbir değeri sıfırlamıyoruz, tüm değerler korunuyor
          })
          .catch((error) => {
            console.log(error, 'error')
            flagcard.add({
              appearance: 'error',
              title: 'Bir hata oluştu',
              children:
                'Veri eklenirken bir hata oluştu. Lütfen tekrar deneyin. Sorununuz düzelmediyse servis sağlayıcısı ile iletişime geçiniz.',
            })
          })
      }
    } else {
      if (onError) {
        onError(props.errors)
      }
    }
  }

  const renderPageHeader = () => {
    const breadcrumbs = (
      <Breadcrumb>
        <BreadcrumbItem text="Anasayfa" href="/" />
        <BreadcrumbItem text="Tanımlama" href="/definition" />
        <BreadcrumbItem
          text="Tanımlama Veri Sayısı Sorgulama"
          href="/definition/query"
        />
        <BreadcrumbItem text="X" />
      </Breadcrumb>
    )

    const bottomBar = (
      <p>X ile alakalı veri sayılarını buradan sorgulayabilirsiniz.</p>
    )

    return (
      <PageHeader
        // actions={actions}
        bottomBar={bottomBar}
        breadcrumbs={breadcrumbs}
      >
        X
      </PageHeader>
    )
  }

  function isOneMonthBefore(selectedDate: any) {
    var currentDate = new Date()
    var oneMonthBefore = new Date(
      currentDate.getFullYear(),
      currentDate.getMonth() - 1,
      currentDate.getDate()
    ).toISOString()

    return selectedDate <= oneMonthBefore
  }

  const getLanguagesV2 = () => {
    definitionService
      .getLanguagesV2()
      .then((res) => {
        setLanguagesV2(res.data.data || [])
      })
      .catch((err) => {
        console.log(err)
        flagcard.add({
          appearance: 'error',
          title: 'Bir hata oluştu',
          children: 'Diller yüklenirken hata oluştu.',
        })
      })
  }

  useEffect(() => {
    handleTwitter()
    getLanguagesV2()
  }, [])

  const renderContent = () => {
    return (
      <React.Fragment>
        <Form onSubmit={form.handleSubmit}>
          <FormSection
            title="Genel bilgiler"
            description="Form üzerinden aşağıdaki genel bilgileri doldurunuz"
          >
            <Row>
              <Column xs={{ size: 12 }}>
                <RadioGroup
                  label="Tanımlama Tipi"
                  name="definitionType"
                  isRequired={true}
                  value={form.values.definitionType}
                  onChange={(props) => {
                    form.handleFieldChange(
                      'definitionType',
                      props.currentTarget.value
                    )
                  }}
                  options={definitionTypeOptions}
                />
              </Column>
            </Row>
            <Row>
              <>
                <Column xs={{ size: 4 }}>
                  <Input
                    name="keyword"
                    placeholder={
                      form.values.definitionType === 'account'
                        ? 'Kullanıcı adı giriniz'
                        : 'Keyword adı giriniz'
                    }
                    description={
                      form.values.definitionType === 'account'
                        ? 'Veri sorgulamak için kullanıcı adı giriniz'
                        : 'Veri toplamak için keyword giriniz (hashtag için # sembolü kullanınız)'
                    }
                    onChange={(props) =>
                      form.handleFieldChange(
                        'definitionValue',
                        props.currentTarget.value
                      )
                    }
                  />
                </Column>
              </>
            </Row>
            <Row>
              <Column xs={{ size: 4 }}>
                <DateTimePicker
                  description="İşlenecek veri aralığının bitiş tarihini seçiniz"
                  label="Secili tarihten"
                  locale="tr"
                  name="fetchKeywordSince"
                  onChange={(props) => {
                    if (isOneMonthBefore(props)) {
                      setDateError(true)
                    } else {
                      setDateError(false)
                    }
                    form.handleFieldChange('fetchKeywordSince', props)
                    setDateFilter({ ...dateFilter, dateSince: props })
                  }}
                  type="default"
                  value={
                    form.values.fetchKeywordSince || 
                    dateFilter.dateSince ||
                    (() => {
                      const oneDayAgo = new Date()
                      oneDayAgo.setDate(oneDayAgo.getDate() - 1)
                      return oneDayAgo.toISOString()
                    })()
                  }
                  times={hoursArray}
                />
              </Column>
              <Column xs={{ size: 4 }}>
                <DateTimePicker
                  description="İşlenecek veri aralığının bitiş tarihini seçiniz"
                  label="Secili tarihe"
                  locale="tr"
                  name="fetchKeywordUntil"
                  onChange={(props) => {
                    setDateError(false)
                    form.handleFieldChange('fetchKeywordUntil', props)
                    setDateFilter({ ...dateFilter, dateUntil: props })
                  }}
                  type="default"
                  value={
                    form.values.fetchKeywordUntil || 
                    dateFilter.dateUntil ||
                    new Date().toISOString()
                  }
                  times={hoursArray}
                />
              </Column>
            </Row>
            {dateError === true && (
              <Row style={{ paddingBottom: '2vh', opacity: 0.7 }}>
                <Column>
                  <span style={{ color: 'red' }}>
                    1 Ay oncesine bir tarih sectiginiz icin diger tarih alaninda
                    tarih secip aralik belirlemeniz gerekmektedir.
                  </span>
                </Column>
              </Row>
            )}

            <Row>
              <Column xs={{ size: 4 }}>
                <Select
                  label="Dahil Edilen Diller"
                  name="includedLanguages"
                  options={languagesV2.length > 0 ? languagesV2.map((lang: any) => ({
                    label: lang.nameTr,
                    value: lang.code,
                  })) : []}
                  value={languagesV2.length > 0 ? languagesV2
                    .filter((lang: any) =>
                      form?.values?.includedLanguages?.includes(lang.code)
                    )
                    .map((lang: any) => ({
                      label: lang.nameTr,
                      value: lang.code,
                    })) : []}
                  onChange={(props: any) => {
                    form.handleFieldChange(
                      'includedLanguages',
                      (props as SelectOptionProps[]).map(
                        (language) => language.value
                      )
                    )
                  }}
                  placeholder="Seçim yapın"
                  isMultiple={true}
                />
              </Column>
            </Row>
            <Row>
              <Column xs={{ size: 4 }}>
                <Select
                  label="Hariç Tutulan Diller"
                  name="excludedLanguages"
                  options={languagesV2.length > 0 ? languagesV2.map((lang: any) => ({
                    label: lang.nameTr,
                    value: lang.code,
                  })) : []}
                  value={languagesV2.length > 0 ? languagesV2
                    .filter((lang: any) =>
                      form?.values?.excludedLanguages?.includes(lang.code)
                    )
                    .map((lang: any) => ({
                      label: lang.nameTr,
                      value: lang.code,
                    })) : []}
                  onChange={(props: any) => {
                    form.handleFieldChange(
                      'excludedLanguages',
                      (props as SelectOptionProps[]).map(
                        (language) => language.value
                      )
                    )
                  }}
                  placeholder="Seçim yapın"
                  isMultiple={true}
                />
              </Column>
            </Row>
          </FormSection>

          <FormFooter>
            <Button
              appearance="primary"
              children="Sorgula"
              isLoading={isLoading}
              type="submit"
            />
          </FormFooter>

          {countData && countData?.resultByDates && (
            <div style={{ marginTop: '2vh', marginBottom: '2vh' }}>
              <Row style={{ display: 'flex', flexDirection: 'column' }}>
                <Column xs={{ size: 4 }}>
                  <span style={{ fontSize: '1rem', fontWeight: 600 }}>
                    Zaman Aralığı ve Değerleri:
                  </span>
                </Column>
                <Column xs={{ size: 12 }}>
                  <span style={{ fontSize: '0.9rem', fontWeight: 600 }}>
                    Toplam Sayı:
                  </span>
                  <span>&nbsp;{countData.totalCount}</span>
                </Column>
                {countData.resultByDates
                  ?.filter((item: any) => item.count > 0)
                  .map((item: any) => (
                    <div
                      key={item.timePeriod}
                      style={{
                        borderBottom: '1px solid black',
                        width: '30%',
                        marginTop: '2vh',
                      }}
                    >
                      <Row>
                        <Column xs={{ size: 6 }}>
                          <span
                            style={{ fontSize: '0.85rem', fontWeight: 600 }}
                          >
                            Değer:
                          </span>
                          &nbsp;{item.count}
                        </Column>
                      </Row>
                      <Row>
                        <Column xs={{ size: 9 }}>
                          <span
                            style={{ fontSize: '0.85rem', fontWeight: 600 }}
                          >
                            Zaman Aralığı:
                          </span>
                          &nbsp;{item.timePeriod}
                        </Column>
                      </Row>
                    </div>
                  ))}
              </Row>
            </div>
          )}
        </Form>
      </React.Fragment>
    )
  }

  return (
    <MainLayout>
      <Page>
        {renderPageHeader()}
        {renderContent()}
      </Page>
    </MainLayout>
  )
}

export default Twitter
